
import { FC, useEffect, useState } from "react";
import Select, { GroupBase, OptionsOrGroups } from "react-select";
import { useForm, Controller } from "react-hook-form";
import { format, parse } from "date-fns";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";

import StatsReports from "../../statsReports";

import { StatisticsProps } from "./types";
import { PatientFilterState, PatientManufacturerFilterStart } from "src/pages/manufacturer/actionDashboard/types";



const ActionDashBoardFilter: FC<StatisticsProps> = ({ updateQueryParams, defaultQueryParams, doctorDropdown, practiceDropdown }): JSX.Element => {
  const [endOpen, setEndOpen] = useState(false);
  const [startOpen, setStartOpen] = useState(false);
  const [hasAppliedFilters, setHasAppliedFilters] = useState(false);

  const { control, handleSubmit, reset, getValues, watch } = useForm<PatientManufacturerFilterStart>({
    mode: 'all',
    defaultValues: defaultQueryParams,
  });

  const start_date = watch("start_date");
  const end_date = watch("end_date");

  const closeDatePickers = () => {
    setStartOpen(false);
    setEndOpen(false);
  };

  useEffect(() => {
    if (!defaultQueryParams) return;
    reset(defaultQueryParams);
  }, [defaultQueryParams, reset]);

  const searchForStats = (values: PatientFilterState) => {
    const updatedValues = {
      ...defaultQueryParams,
      ...values,
      global_doctor_id:
        values.global_doctor_id ?
          (typeof values.global_doctor_id === "string" ? values.global_doctor_id : (values.global_doctor_id as unknown as { value: string; label: string; }).value)
          : "",
      practice_id:
        values.practice_id ?
          (typeof values.practice_id === "string" ? values.practice_id : (values.practice_id as unknown as { value: string; label: string; }).value)
          : "",
    };

    updateQueryParams(updatedValues, false);
    setHasAppliedFilters(true);
  };

  const clearFormData = () => {
    const values = {
      ...defaultQueryParams,
      start_date: format((new Date()).setDate((new Date()).getDate() - 60), "yyyy-MM-dd"),
      end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
      practice_id: "",
      global_doctor_id: "",
      case_id: "",
      global_patient_id: "",
    };

    reset(values);
    updateQueryParams(getValues(), true);
    setHasAppliedFilters(false);
  };

  return (
    <form onSubmit={handleSubmit(searchForStats)}>
      <div className="row g-2 statistics-filter">
        <div className="col date-col position-relative">
          <Controller
            name="start_date"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <><DatePicker
                selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                customInput={
                  <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                    <input {...inputProps} />}
                  </ReactInputMask>
                }
                className="form-control rounded-1" wrapperClassName="w-100"
                placeholderText="mm/dd/yyyy"
                dateFormat="MM/dd/yyyy"
                maxDate={end_date ? new Date(end_date) : undefined}
                open={startOpen}
                onFocus={() => {
                  setStartOpen(true);
                  setEndOpen(false);
                }}
                onClickOutside={() => setStartOpen(false)}
                onSelect={() => setStartOpen(false)}
                showMonthDropdown
                showYearDropdown
              />
              <i
                className="bi bi-calendar position-absolute"
                style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                }}
            >
            </i>
                                        </>
            )}
          />
        </div>
        <div className="col date-col position-relative">
          <Controller
            name="end_date"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <><DatePicker
                selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) => <input {...inputProps} />}</ReactInputMask>}
                className="form-control rounded-1" wrapperClassName="w-100"
                placeholderText="mm/dd/yyyy"
                dateFormat="MM/dd/yyyy"
                showMonthDropdown
                showYearDropdown
                minDate={start_date ? new Date(start_date) : undefined}
                open={endOpen}
                onFocus={() => {
                  setEndOpen(true);
                  setStartOpen(false);
                }}
                onClickOutside={() => setEndOpen(false)}
                onSelect={() => setEndOpen(false)}
              />
              <i
                                            className="bi bi-calendar position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                            }}
                                        ></i>
                                        </>
            )}
          />
        </div>
        <div className="col filters-col">
          <Controller
            name="practice_id"
            control={control}
            defaultValue=""
            render={({ field, fieldState: { error } }) => (
                <Select
                    isClearable={true}
                    isSearchable={true}
                    options={(
                        practiceDropdown &&
                        practiceDropdown.length > 0 ?
                            practiceDropdown.map((item) => ({
                                value: item.id.toString(),
                                label: item.name
                            }))
                            : []
                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                    id="filter_type"
                    {...field}
                    placeholder="Select Practice..."
                    value={(() => {
                      if (field.value) {
                        const foundPrac = practiceDropdown?.find((prac) => prac.id.toString() === ((field.value as unknown as { value: string; })?.value || field.value));
                        return foundPrac ? { label: foundPrac.name, value: Number(foundPrac.id) } : "";
                      } else
                        return "";
                    })()}
                    onChange={(val) => {
                      if (val) field.onChange(val)
                      else {
                        field.onChange("")
                        if (hasAppliedFilters) {
                        searchForStats({ ...getValues(), practice_id: "" });
                        }
                      }
                    }}
                />
              // <HubInputField
              //   inputId="practice_id"
              //   isRequired={true}
              //   isRowBased={true}
              //   isRowInsideAnother={true}
              //   field={field}
              //   error={error}
              //   isDropdown={true}
              //   isSearchable={true}
              //   inputPlaceholder="Select Practice..."
              //   dropdownData={(
              //     filteredPracticeListing &&
              //     filteredPracticeListing.length > 0 ?
              //     filteredPracticeListing.map((item) => ({
              //       value: item.id.toString(),
              //       label: item.name
              //     }))
              //     : []
              //   ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
              // />
            )}
          />
        </div>
        <div className="col filters-col">
           <Controller
            name="global_doctor_id"
            control={control}
            defaultValue=""
            render={({ field, fieldState: { error } }) => (
                <Select
                    isClearable={true}
                    isSearchable={true}
                    options={(
                        doctorDropdown &&
                        doctorDropdown.length > 0 ?
                            doctorDropdown.map((item) => ({
                                value: item.id.toString(),
                                label: item.name
                            }))
                            : []
                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                    id="filter_type"
                    {...field}
                    placeholder="Select Doctor..."
                    value={(() => {
                      if (field.value) {
                        const foundDoc = doctorDropdown?.find((doc) => doc.id.toString() === ((field.value as unknown as { value: string; })?.value || field.value));
                        return foundDoc ? { label: foundDoc.name, value: foundDoc.id } : "";
                      } else
                        return "";
                    })()}
                    onChange={(val) => {
                      if (val) field.onChange(val)
                      else {
                        field.onChange("")
                        if (hasAppliedFilters) {
                        searchForStats({ ...getValues(), global_doctor_id: "" });
                        }
                      }
                    }}
                />
              // <HubInputField
              //   inputId="global_doctor_id"
              //   isRequired={true}
              //   isRowBased={true}
              //   isRowInsideAnother={true}
              //   field={field}
              //   error={error}
              //   isDropdown={true}
              //   isSearchable={true}
              //   inputPlaceholder="Select Doctor..."
              //   dropdownData={(
              //     filteredDocListing &&
              //     filteredDocListing.length > 0 ?
              //     filteredDocListing.map((item) => ({
              //       value: item.id.toString(),
              //       label: item.name
              //     }))
              //     : []
              //   ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
              // />
            )}
          />
        </div>
        <div className="col date-col">
          <Controller
            name="global_patient_id"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input className="form-control" type={"text"} id={'global_patient_id'} placeholder={'Pt. ID'}  {...field} onFocus={closeDatePickers} />

            )}
          />
        </div>
        <div className="col date-col">
          <Controller
            name="case_id"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input className="form-control" type={"text"} id={'case_id'} placeholder={'Case ID'}  {...field} onFocus={closeDatePickers} />
            )}
          />
        </div>
        <div className="col filter-buttons d-flex gap-2">
            <button type="submit" className="btn btn-blue text-nowrap">
                <i className="fas fa-sync-alt"></i> Refresh
            </button>
          <button type="button" onClick={clearFormData} className="btn btn-light text-nowrap">
              Clear
          </button>
        </div>
      </div>

      <StatsReports getValues={getValues} />
    </form>
  );
};

export default ActionDashBoardFilter;
